import SupervisionInfo  from './SupervisionInfo.vue'
export default SupervisionInfo
